
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/[region]/ranking/[slug]/[year]",
      function () {
        return require("private-next-pages/well/[region]/ranking/[slug]/[year]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/[region]/ranking/[slug]/[year]"])
      });
    }
  